<template>
  <div style="height: 800px;">
    <van-sticky>
      <wx-my-profile style="background-color: white"></wx-my-profile>
    </van-sticky>

    <van-cell-group style="display: flex; flex-direction: column;">
      <van-cell v-for="(item, index) of linkList" :key="index" is-link @click="clickItem(item)">
        <template #title>
          {{ item.title }}
        </template>
      </van-cell>
    </van-cell-group>

    <div style="background-color: #e1e1e1; flex-grow: 1; display: flex; justify-content: center;">
      <van-button type="danger" size="normal" style="margin: 20px; width: 80%" @click="logout" round>退出登录
      </van-button>
    </div>

    <van-popup v-model="page.show" position="bottom" style="width: 100%; height: 100%">
      <div>
        <van-nav-bar
          left-arrow
          :title="page.title"
          left-text="返回"
          @click-left="pageShow">
        </van-nav-bar>
        <component :is="page.name" :delivery="page.name === 'wx-work-list'" :active="page.active"
                   @btnpageshow="pageShow"></component>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Button, Cell, CellGroup, NavBar, Popup, Toast, Sticky } from 'vant'
import WxHistoryWorkList from '@/views/wx/WxHistoryWorkList'
import WxWorkList from '@/views/wx/WxWorkList'
import WxPunchInRecord from '@/views/wx/punch/WxPunchInRecord'
import WxNotOpenPage from '@/views/wx/WxNotOpenPage'
import WxPunchMain from '@/views/wx/punch/index'
import WxMyProfile from '@/views/wx/WxMyProfile'
import WxWorkReport from '@/views/wx/WxWorkReport'
import WxWorkAdd from '@/views/wx/work-add'
import WxInbound from '@/views/wx/product/WxInbound'
import WxOutbound from '@/views/wx/product/WxOutbound'
import WxNeiling from '@/views/wx/product/WxNeiling'
import { myInfo } from '@/utils/request'

export default {
  provide () {
    return {
      resetPage: () => {
        this.page.show = false
      }
    }
  },
  name: 'WxMyInfo',
  components: {
    WxMyProfile,
    WxPunchMain,
    WxNotOpenPage,
    WxPunchInRecord,
    WxWorkList,
    WxHistoryWorkList,
    WxWorkReport,
    WxWorkAdd,
    WxInbound,
    WxOutbound,
    WxNeiling,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Toast.name]: Toast
  },
  data () {
    return {
      linkList: [
        {
          title: '历史工单',
          name: 'wx-history-work-list'
        },
        {
          title: '绩效查询',
          name: 'wx-work-report'
        },
        {
          title: 'KPI报表',
          name: 'wx-not-open-page'
        },
        {
          title: '考勤打卡',
          name: 'wx-punch-main',
          active: 0
        },
        {
          title: '考勤记录',
          name: 'wx-punch-main',
          active: 1
        },
        {
          title: '交车查询',
          name: 'wx-work-list',
          delivery: true
        },
        {
          title: '用料查询',
          name: 'wx-not-open-page'
        },
        {
          title: '用料申请',
          name: 'wx-not-open-page'
        },
        {
          title: '新增工单',
          name: 'wx-work-add'
        },
        {
          title: '入库管理',
          name: 'wx_inbound'
        },
        {
          title: '出库管理',
          name: 'wx_outbound'
        },
        {
          title: '内领管理',
          name: 'wx_neiling'
        }
      ],
      page: {
        show: false,
        title: '',
        name: '',
        active: null
      },
      addworkShow: false
    }
  },
  created () {
    myInfo().then(response => {
      for (var list of response.data.user.permissions) {
        if (list === 'ADD_WORK') {
          this.addworkShow = true
        }
      }
    })
  },
  methods: {
    clickItem (item) {
      if (item.name.indexOf('_') >= 0) {
        this.$router.push({
          path: '/' + item.name
        })
        return
      }

      if (item.name === 'wx-work-add') {
        if (!this.addworkShow) {
          Toast.fail('您没有此权限')
          return
        }
      }
      this.page.show = true
      this.page.title = item.title
      this.page.name = item.name
      this.page.active = item.active
    },
    logout () {
      this.$store.dispatch('user/unbind')
    },
    pageShow () {
      this.page.show = false
      this.page.title = ''
      this.page.name = ''
      this.page.active = null
    }
  }
}
</script>

<style scoped>

</style>
